export const CUMPLIMIENTO_DESCARGA = 1;